import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const getToastOptions = (message, extraOptions = {}) => {
  const text = String(message || '');
  const hasNewlines = text.includes('\n') || text.includes('\r');
  return {
    position: 'top-right',
    autoClose: extraOptions.autoClose ?? (hasNewlines ? 10000 : 5000),
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...extraOptions
  };
};

const showAlert = (message, type, extraOptions = {}) => {
  const options = getToastOptions(message, extraOptions);
  switch (type) {
    case 'info':
      toast.info(message, options);
      break;
    case 'success':
      toast.success(message, options);
      break;
    case 'warning':
      toast.warn(message, options);
      break;
    case 'error':
      toast.error(message, options);
      break;

    default:
      toast(message, options);
  }
};

export default showAlert;
